import { useTranslation } from 'react-i18next'

export default function TotalsSection({ form, setField }) {
	const { t } = useTranslation()

	return (
		<div className="grid grid-cols-1 md:grid-cols-2 gap-3 px-4 sm:px-0">

			<div>
				<label className="block text-sm font-medium text-gray-700 mb-1">{t('invoices.form.date')}</label>
				<input
					type="invoiceDate"
					value={form.invoiceDate}
					onChange={e => setField('invoiceDate', e.target.value)}
					className="block w-full rounded-lg border-0 py-2.5 px-3.5 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600"
				/>
			</div>

			<div>
				<label className="block text-sm font-medium text-gray-700 mb-1">{t('invoices.form.dueDate')}</label>
				<input
					type="date"
					value={form.dueDate}
					onChange={e => setField('dueDate', e.target.value)}
					className="block w-full rounded-lg border-0 py-2.5 px-3.5 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600"
				/>
			</div>

		</div>
	)
}
